import { USER_TYPES } from "./Constants";
import { DefaultLanguage, LOCALISE_LANGUAGES } from "./LanguageConstants";
import { SURVEY_TYPE } from "./SurveyConstants";
import { UPLOAD_TYPE } from "./UploadFilesConstants";

export const PublicVariables = {
    ldFlags: {},
    defaultLanguage: DefaultLanguage,
    currentLanguageObj: LOCALISE_LANGUAGES.find((lang) => lang.languageCode === DefaultLanguage),
    featureFlag: {
        SMSSUPPORTOPTION: null,
    },
    isMobile: false,
    isIOSDevice: false,
    agentDefaultColor: "#53e504",
    isOnlyUploadImageMeet: false,
    locationIntervalId: "",
    fromButton: false, // for end call
    onJoinCallAudio: false, // for automatically starts audio
};

/* This object will be used globaly across entire project to access variables */
export const GLOBAL_MEETING_DATA = {
    userType: USER_TYPES.AGENT, //Set default user as Agent
    survey: {
        surveyType: SURVEY_TYPE.SURVEYMONKEY,
        openSurvey: false,
        isAgentForSurvey: "",
        surveyDuration: "",
        surveyURL: "",
        openNewTab: "",
        inSurveyAgentOrGuestName: "",
    },
    domainInfo: {
        edition: "",
        domainName: "",
        domainId: "",
        domainEmail: "",
        domainUrl: "",
    },
    sessionId: "",
    blitzzUserName: "",
    cid: "",
    companyEmail: "",
    releaseVersion: "",
    smsTemplate: "",
    ucid: "",
    pid: "",
    smsSupportOption: null,
    externalUserName: "",
    remainingFileCount: 0,
    isAgent: false,
    isGuest: false,
    isCustomDomain: false,
    showBackButton: false,
    closetabParams: 0,
    platformParams: "",
    redirectParams: "",
    homeScreenButtonParams: 0,
    device_type: 3, // for the web
    markupLiveStream: false,
    uploadFileAction: UPLOAD_TYPE.EMPTY,
    onlySecondsDiff: false, //for schedule session
    isRoomCallHasLogsParams: false, // for room call log button
    androidOSBelow15: false,
};

/* This object will be used globaly across entire project to access call variable only */
export const CALL_DATA = {
    memberToken: "",
    memberId: "",
    agentUserName: "",
    localIdentity: "",
    participantIdentity: null,
    Latitude: 0,
    Longitude: 0,
    callstatsNetType: "",
    participantUserName: "",
    callstatsNetSpeed: "",
    roomSID: "",
    recordingRoomKey: null,
    isObserver: false,
    firstTimeUploadForSuccess: true,
    firstTimeUploadForFailed: true,
    batteryNetworkInfo: {
        batteryState: "",
        batteryObject: null,
        batteryLevel: null,
        localBatteryValue: null,
        localBatteryLow: null,
    },
    referenceId: "",
    storageType: null,
    myVideoON: false,
    myscreenShareON: false,
    localFlash: true,
    disabledFlash: true,
    localAudioMsg: null,
    remoteAudioMsg: null,
    gblAudioAgentMsgShown: false,
    roomDisconnect: false,
    rejoinPopupNotShow: false,
    isOfflineModeActive: false, // Flag to indicate if the call is in offline mode
    iOSPrivateMode: false, // Flag to indicate if the call is in iOS private mode
    transcriptionId: "", // For Live Caption transcription Id
};

export const IMAGE_COMPRESSION = {
    FOR_WEB: {},
    WEB_MIN_SIZE: 0,
    MAX_IMAGE_SIZE: 0,
};

/* Image size keys that we receive from BE side  */
export const IMAGE_SIZE_KEYS = {
    COMPRESSION_DIVISION: 10,
    BELOW_DIVISION: "BELOW_10MB",
    ABOVE_DIVISION: "ABOVE_10MB",
};

/*  compression type that we receive from BE side, keep keys in string format only to match with BE response */
export const COMPRESSION_TYPE = {
    1: "LOW",
    2: "ADAPTIVE",
    3: "HIGH",
};

export const MIME_TYPE = {
    PNG: "image/png",
    JPEG: "image/jpeg",
};

export const DOCUMENT_VISIBILITY_STATE = {
    VISIBLE: "visible",
    HIDDEN: "hidden",
};
